import {Box, Chip, Stack, Typography} from '@mui/material';
import {SessionQuestion} from '@cp/model';
import MarkdownContentRenderer from '../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';
import BondGraphRenderer from '../../bonds/bondGraphRenderer/BondGraphRenderer';

interface QuestionReviewQuestionSummaryProps {
  question: SessionQuestion;
  index: number;
}

export default function QuestionReviewQuestionSummary({question, index}: QuestionReviewQuestionSummaryProps) {
  return (
    <Box sx={{width: '100%'}}>
      {/* Main question content */}
      <Stack direction={{xs: 'column', sm: 'row'}} spacing={2} alignItems={{xs: 'flex-start', sm: 'center'}}>
        {/* Question number chip */}
        <Chip
          label={`Q${index + 1}`}
          size="small"
          color={question.isCorrect ? 'success' : 'error'}
          sx={{
            minWidth: 40,
            flexShrink: 0,
            alignSelf: {xs: 'flex-start', sm: 'center'},
          }}
        />

        <Box sx={{flex: 1}}>
          <BondGraphRenderer graphJsonString={question.graphJsonString} height={160} />
          <Typography
            variant="body1"
            component="div"
            sx={{
              fontWeight: 500,
              mb: 1,
              lineHeight: 1.4,
              wordBreak: 'break-word',
            }}
          >
            <MarkdownContentRenderer content={question.questionText} />
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
